/* src/pages/setup/components/Company Defaults/CompanyDefaultsPage.jsx */
import React, { useState } from "react";
import CompanyDefaultsForm from "./components/CompanyDefaultsForm";

export default function CompanyDefaultsPage() {
  const [feature, setFeature] = useState(null);
  const [panelOpen, setPanelOpen] = useState(false);

  return (
    <div className="w-full h-screen pt-36 overflow-hidden p-6">
      <CompanyDefaultsForm
        feature={feature}
        setFeature={setFeature}
        panelOpen={panelOpen}
        setPanelOpen={setPanelOpen}
      />
    </div>
  );
}
